<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <!-- Page Header - Title -->
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{
          $t("campaigns.createnew")
          }}
        </span>
        <h3 class="page-title">{{ $t("campaigns.industrytype") }}</h3>
      </d-col>
    </d-row>
    <!-- Page Header - Title -->
    <d-col lg="12">
      <d-progress theme="success" :value="50" :max="100" />
    </d-col>
    <!-- Campaign Name -->
    <d-col lg="12" class="mx-auto mt-4">
      <d-card class="card-small mb-4">
        <d-card-body class="px-4 pb-4">
          <d-form>
            <d-form-row>
              <d-col lg="6">
                <d-form-text tag="h6" class="mt-1 mb-3">
                  {{
                  $t("campaigns.addname")
                  }}
                </d-form-text>
                <d-input
                  type="text"
                  id="campaignName"
                  :placeholder="$t('campaigns.addnameplaceholder')"
                  v-model="newCampaign.name"
                />
              </d-col>
            </d-form-row>
          </d-form>
        </d-card-body>
      </d-card>
      <!-- End Campaign Name -->

      <!-- Industry & Sub-Industry -->
      <d-card class="card-small mb-4">
        <d-card-body class="px-4 pb-2">
          <d-form>
            <d-form-row>
              <d-col class="mb-3">
                <d-form-text tag="h6" class="m-0">
                  {{
                  $t("campaigns.industry")
                  }}
                </d-form-text>
                <d-form-text tag="p" class="text-muted m-0 mb-2">
                  {{
                  $t("campaigns.industrysub")
                  }}
                </d-form-text>
                <vue-simple-suggest
                  class="float-right"
                  :placeholder="$t('campaigns.industrysearch')"
                  v-model="chosen"
                  :list="industrySuggestionList"
                  :filter-by-query="true"
                ></vue-simple-suggest>
              </d-col>
            </d-form-row>
            <d-form-row class="mb-4">
              <form class="mt-2 campaign-checkbox">
                <span v-for="industry in filteredIndustries" :key="industry.name">
                  <input
                    class="checkbox-tools"
                    type="checkbox"
                    :name="industry.name"
                    :id="industry.name"
                    v-model="industry.isSelected"
                    @click="selectIndustry(industry)"
                  />
                  <label
                    class="for-checkbox-tools checkbox-resizer"
                    :class="{ highlightitem: industry.name === chosen }"
                    :for="industry.name"
                  >{{ industry.name }}</label>
                </span>
              </form>
            </d-form-row>
            <!-- Sub Industry -->
            <template>
              <d-form-row v-for="industry in industries" :key="industry.industry">
                <div
                  v-if="
                    industry.isSelected &&
                      industry.sub &&
                      industry.sub.length > 1
                  "
                >
                  <d-form class="m-2 campaign-checkbox">
                    <d-form-text tag="p" class="text-muted m-0 mb-4">
                      <u class="ind-text color-accent">{{ industry.name }}</u>
                      <br />
                      {{ $t("campaigns.subcategory") }}
                      <span>
                        <d-button
                          @click.prevent="selectAll(industry)"
                          size="sm"
                          outline
                          pill
                          class="resize-pill m-2"
                          theme="success"
                        >
                          <i class="material-icons">&#XE145;</i>
                          {{ $t("campaigns.selectall") }}
                        </d-button>
                        <d-button
                          size="sm"
                          outline
                          pill
                          class="resize-pill my-2 mr-2"
                          theme="warning"
                          @click.prevent="unselectAll(industry)"
                        >
                          <i class="material-icons">remove</i>
                          {{ $t("campaigns.unselectall") }}
                        </d-button>
                      </span>
                    </d-form-text>
                  </d-form>
                  <span class="float-left">
                    <span v-for="sub in industry.sub" :key="sub.name">
                      <input
                        class="checkbox-tools"
                        type="checkbox"
                        :name="sub.name"
                        :id="sub.name"
                        v-model="sub.isSelected"
                      />
                      <label
                        class="for-checkbox-tools checkbox-sub"
                        @click.prevent="selectSub(sub)"
                        :for="sub.name"
                      >{{ sub.name }}</label>
                    </span>
                  </span>
                </div>
              </d-form-row>
            </template>
            <!-- End Sub Industry -->
          </d-form>
        </d-card-body>
      </d-card>
      <!-- End New Industry-->

      <!-- Filter by Keywords -->
      <d-card class="card-small edit-user-details mb-4">
        <d-card-header class="p-0"></d-card-header>
        <d-card-body class="p-0">
          <d-form class="py-3 pb-4">
            <d-form-row class="mx-4">
              <d-col lg="12">
                <d-form-text tag="h6" class="m-0">
                  {{
                  $t("campaigns.keywordtitle")
                  }}
                </d-form-text>
                <d-form-text tag="p" class="text-muted m-0">
                  {{
                  $t("campaigns.keywordsub")
                  }}
                </d-form-text>
                <vue-tags-input
                  class="mt-4"
                  v-model="keywordTag"
                  :tags="newCampaign.keywordTags"
                  @tags-changed="newTags => (newCampaign.keywordTags = newTags)"
                  :placeholder="$t('campaigns.keywordplaceholder')"
                />
              </d-col>
            </d-form-row>
          </d-form>
        </d-card-body>
      </d-card>
      <!-- End Company Description -->

      <!-- Location -->
      <d-card class="card-small edit-user-details my-4 z-20">
        <d-card-body class="px-4 pb-4">
          <d-form>
            <d-form-row>
              <d-col class="mb-3">
                <d-form-text tag="h6" class="m-0">
                  {{
                  $t("campaigns.location")
                  }}
                </d-form-text>
                <d-form-text tag="p" class="m-0 mb-2 text-muted">
                  {{
                  $t("campaigns.locationsub")
                  }}
                </d-form-text>
              </d-col>
            </d-form-row>
            <d-form-row>
              <!-- Region Select -->
              <!-- <d-col lg="3">
                <d-form-text tag="p" class="m-0 mb-2 text-muted">By Region</d-form-text>
                <vue-tags-input
                  v-model="regionTag"
                  :tags="newCampaign.regionTags"
                  :autocomplete-items="regions"
                  @tags-changed="newTags => newCampaign.regionTags = newTags"
                  placeholder="All Regions"
                />
              </d-col>-->

              <!-- <span class="m-2">or</span> -->

              <!-- Country Select -->
              <d-col lg="8">
                <d-form-text tag="p" class="z-20 m-0 mb-2 text-muted">
                  {{
                  $t("campaigns.bycountry")
                  }}
                </d-form-text>
                <vue-tags-input
                  v-model="countryTag"
                  :tags="newCampaign.countryTags"
                  :autocomplete-items="filteredCountries"
                  :add-only-from-autocomplete="true"
                  @tags-changed="newTags => (newCampaign.countryTags = newTags)"
                  :placeholder="$t('campaigns.addcountry')"
                />
              </d-col>

              <!-- <span class="m-2">or</span> -->

              <!-- City Select -->
              <!-- <d-col lg="3">
                <d-form-text tag="p" class="m-0 mb-2 text-muted">By City</d-form-text>
                <vue-tags-input
                  v-model="cityTag"
                  :tags="newCampaign.cityTags"
                  :autocomplete-items="cities"
                  @tags-changed="newTags => newCampaign.cityTags = newTags"
                  placeholder="All Cities"
                />
              </d-col>-->
            </d-form-row>
          </d-form>
        </d-card-body>
      </d-card>
      <!-- End Location -->

      <!-- Company Size -->
      <d-card class="card-small edit-user-details mb-4">
        <d-card-body class="px-4 pb-4">
          <d-form v-on:submit.prevent>
            <d-form-row>
              <d-col class="mb-3">
                <d-form-text tag="h6" class="m-0">
                  {{
                  $t("campaigns.companysize")
                  }}
                </d-form-text>
                <d-form-text tag="p" class="text-muted m-0 mb-2">
                  {{
                  $t("campaigns.companysizesub")
                  }}
                </d-form-text>
              </d-col>
            </d-form-row>
            <div
              aria-role="group"
              aria-label="Button group"
              class="mb-2 btn-group-undefined btn-group"
            >
              <button
                v-for="option in companySizeOptions"
                class="btn btn-white btn-primary"
                :key="option.text"
                :class="{ active: newCampaign.companySize === option.value }"
                @click="selectCompanySize(option)"
              >
                <strong>{{ option.text }}</strong>
                / {{ option.subtext }}
              </button>
            </div>
          </d-form>
        </d-card-body>
      </d-card>
      <!-- End Company Size -->

      <!-- Limit Contacts Per Company -->
      <d-card class="card-small edit-user-details mb-4">
        <d-card-body class="px-4 pb-4">
          <d-form v-on:submit.prevent>
            <d-form-row>
              <d-col>
                <d-form-text tag="h6" class="m-0">
                  {{
                  $t("campaigns.contacts")
                  }}
                </d-form-text>
                <d-form-text tag="p" class="text-muted m-0 mb-3">
                  {{
                  $t("campaigns.contactrecommend")
                  }}
                </d-form-text>
                <form-row class="mt-3">
                  <form-text>{{ $t("campaigns.maxcontact") }}</form-text>
                  <div class="mt-3">
                    <form-text-row
                      aria-role="group"
                      aria-label="Button group"
                      class="mb-2 btn-group-undefined btn-group"
                    >
                      <button
                        v-for="option in [1, 2, 3]"
                        :key="option"
                        @click="selectContactCount(option)"
                        class="btn btn-white btn-primary"
                        :class="{ active: newCampaign.contactCount === option }"
                      >{{ option }}</button>
                    </form-text-row>
                  </div>
                </form-row>
              </d-col>
            </d-form-row>
          </d-form>
        </d-card-body>
      </d-card>
      <!-- Limit Contacts Per Company -->

      <!-- Tech Used -->
      <!-- <d-card class="card-small edit-user-details my-4">
        <d-card-body class="px-4 pb-4">
          <d-form>
            <d-form-row>
              <d-col class="mb-3">
                <d-form-text tag="h6" class="m-0">Tech Stack</d-form-text>
                <d-form-text
                  tag="p"
                  class="m-0 mb-2 text-muted"
                >Find customers by the tech they are currently using or not using</d-form-text>
              </d-col>
            </d-form-row>
            <d-form>
              <d-form-row>
                <d-col lg="6">
                  <d-input type="text" id="campaignName" placeholder="Baremetrics, React.js, "/>
                </d-col>
              </d-form-row>
            </d-form>
          </d-form>
        </d-card-body>
      </d-card>-->
      <!-- End Tech Used -->

      <!-- Competitor Tech Search -->
      <!-- <d-card class="card-small edit-user-details my-4">
        <d-card-body class="px-4 pb-4">
          <d-form>
            <d-form-row>
              <d-col class="mb-3">
                <d-form-text tag="h6" class="m-0">Competitor Customers</d-form-text>
              </d-col>
            </d-form-row>
            <d-form>
              <d-form-row>
                <d-col lg="6">
                  <vue-tags-input
                    v-model="competitorTag"
                    :tags="competitorTags"
                    :autocomplete-items="competitors"
                    @tags-changed="newTags => competitorTags = newTags"
                    placeholder="Find customers that are using your competitor's products"
                  />
                </d-col>
              </d-form-row>
            </d-form>
          </d-form>
        </d-card-body>
      </d-card>-->
      <!-- End Competitor Tech Search  -->

      <!-- Tech Spend -->
      <!--
      <d-card class="card-small edit-user-details mb-4">
        <d-card-body class="px-4">
          <d-form>
            <d-form-row>
              <d-col class="mb-3">
                <d-form-text tag="h6" class="m-0">Prospect Tech Spend</d-form-text>
                <d-form-text
                  tag="p"
                  class="text-muted m-0"
                >Prefer prospects by how much they spend on tech each month</d-form-text>
              </d-col>
            </d-form-row>
            <d-col>
              <d-slider
                v-model="sliderValue"
                :value="['0', '100000']"
                :options="{ pips: { mode: 'steps', stepped: true, density: 1000 } }"
                :connect="true"
                class="form-slider"
              />
              <span>Slider Value: {{ sliderValue }}</span>
            </d-col>
          </d-form>
        </d-card-body>
      </d-card>
      -->
      <!-- End Tech Spend -->

      <!-- Company Age -->
      <!-- <d-card class="card-small edit-user-details mb-4">
        <d-card-header class="p-0"></d-card-header>
        <d-card-body class="px-4">
          <d-form>
            <d-form-row>
              <d-col class="mb-3">
                <d-form-text tag="h6" class="m-0">Company Age</d-form-text>
                <d-col class="pl-0 mb-2">
                  <d-form-text
                    tag="p"
                    class="text-muted m-0"
                  >Filter companies by how long they've been in business</d-form-text>
                </d-col>
              </d-col>
            </d-form-row>

            <d-form-row>
              <d-col lg="3">
                <d-form-select v-model="yearSelected" :options="years"/>
              </d-col>
            </d-form-row>
          </d-form>
        </d-card-body>
      </d-card>-->
      <!-- End Company Age  -->

      <!-- Save Changes -->
      <d-card class="mb-4">
        <d-card-footer class="form-end">
          <d-row class="py-2">
            <!-- Showing Percentage Progress -->
            <d-col lg="12">
              <div>
                <d-button
                  @click="navigateNext()"
                  size="sm"
                  class="btn-accent btn-form-end ml-auto d-table float-right"
                >{{ $t("campaigns.next") }}</d-button>
                <span class="pretext-btn pt-1 text-right">
                  {{ $t("campaigns.nextpretext") }}
                  <i class="material-icons">arrow_forward</i>
                </span>
              </div>
            </d-col>
          </d-row>
        </d-card-footer>
      </d-card>
      <!-- End Save Changes -->
    </d-col>
  </d-container>
</template>

<script>
import constants from "@/data";
import _ from "lodash";
import { CAMPAIGN_SET_NEW } from "@/store/types";
import { mapGetters } from "vuex";
import VueSimpleSuggest from "vue-simple-suggest";

export default {
  components: {
    VueSimpleSuggest
  },
  mounted() {
    this.countries = constants.countries();
    this.industries = _.orderBy(
      constants.industries().industries,
      ["name"],
      ["asc"]
    );
    this.industrySuggestionList = constants.industries().suggestionList;
    if (this.getNewCampaign) {
      this.newCampaign = _.cloneDeep(this.getNewCampaign);
      this.industries = this.industries.map(industry => {
        if (
          this.newCampaign.industries &&
          this.newCampaign.industries.includes(industry.name)
        ) {
          industry.isSelected = true;
        }
        return industry;
      });
    }
  },
  computed: {
    ...mapGetters(["getNewCampaign"]),
    filteredIndustries() {
      return this.industries;
    },
    filteredCountries() {
      return this.countries.filter(i => {
        return (
          i.text.toLowerCase().indexOf(this.countryTag.toLowerCase()) !== -1
        );
      });
    }
  },
  data() {
    return {
      // industries: [],
      industrySuggestionList: [],
      chosen: "",
      newCampaign: {
        companySize: "",
        contactCount: null
      },
      keywordTag: "",
      companySizeOptions: [
        {
          value: "1~200",
          text: "Small",
          subtext: "1-200"
        },
        {
          value: "200~1000",
          text: "Medium",
          subtext: "200-1000"
        },
        {
          value: "1000~",
          text: "Large",
          subtext: "1000+"
        }
      ],
      industries: [],
      selected: null,
      regionTag: "",
      countryTag: "",
      cityTag: "",
      // Should create tags after value is selected
      regionSelected: "All Regions",
      regions: [
        { value: "All Regions", text: "All Regions" },
        { value: "North America", text: "North America" },
        { value: "Europe", text: "Europe" },
        { value: "Asia", text: "Asia" },
        { value: "Middle East", text: "Middle East" }
      ],
      countrySelected: "All Countries",
      countries: [],
      citySelected: "All Cities",
      cities: [
        { value: "All Cities", text: "All Cities" },
        { value: "New York", text: "New York" },
        { value: "Seoul", text: "Seoul" },
        { value: "Tokyo", text: "Tokyo" }
      ],
      techStackSelected: "Choose a technology",
      types: [
        { value: "Ecommerce", text: "Ecommerce stores" },
        { value: "Live Chat", text: "Live chat" },
        { value: "React.js", text: "React.js" },
        { value: "Vue.js", text: "Vue.js" },
        { value: "Baremetrics", text: "Baremetrics" }
      ],
      competitorSelected: "",
      competitors: [
        { value: "Retargeting", text: "Retargeting" },
        { value: "Live Chat", text: "Live chat" },
        { value: "Ecommerce stores", text: "Ecommerce stores" },
        { value: "Vue.js", text: "Vue.js" }
      ],
      sliderValue: ["10", "80"]
    };
  },
  methods: {
    selectSub(sub) {
      sub.isSelected = !sub.isSelected;
    },
    selectAll(industry) {
      industry.sub.map(sub => {
        sub.isSelected = true;
      });
    },
    unselectAll(industry) {
      industry.sub.map(sub => {
        sub.isSelected = false;
      });
    },
    selectIndustry(industry) {
      industry.isSelected = !industry.isSelected;
    },
    selectContactCount(option) {
      this.newCampaign.contactCount = option;
    },
    selectCompanySize(option) {
      if (this.newCampaign.companySize === option.value) {
        this.newCampaign.companySize = "";
      } else {
        this.newCampaign.companySize = option.value;
      }
    },
    navigateNext() {
      const industries = this.industries
        .filter(industry => industry.isSelected)
        .map(industry => industry.name);

      const subindustries = this.industries
        .filter(industry => industry.isSelected)
        .map(industry => {
          return industry.sub.filter(sub => sub.isSelected);
        })
        .flat()
        .map(sub => sub.name);

      this.$store.commit(CAMPAIGN_SET_NEW, {
        ...this.newCampaign,
        industries,
        subindustries
      });

      this.$router.push({ name: "new-campaign-2" });
    },
    // Vue-simple-suggest
    simpleSuggestionList() {
      return ["Connect me 1", "Connect me 2", "abcdefghijklmnopqrstuvwxyz"];
    }
  }
};
</script>

<style lang="scss" scoped>
.z-20 {
  z-index: 20;
}

.resize-pill {
  padding: 5px 13px 4px 10px;
}

.ind-text {
  text-decoration: none;
  font-weight: bold;
}
.default-input.designed {
  height: auto;
  line-height: 1.5;
  background-color: #fff;
  border: 1px solid #d8d8d8 !important;
  will-change: border-color, box-shadow;
  border-radius: 0.25rem;
  box-shadow: none;
  transition: box-shadow 250ms cubic-bezier(0.27, 0.01, 0.38, 1.06),
    border 250ms cubic-bezier(0.27, 0.01, 0.38, 1.06);
  &:hover {
    border-color: #cacaca !important;
  }
  &:focus-within {
    border-color: #007bff !important;
    box-shadow: 0 0.313rem 0.719rem rgba(0, 123, 255, 0.1),
      0 0.156rem 0.125rem rgba(0, 0, 0, 0.06) !important;
  }
}
</style>
